export default {
    moves: 'Movimientos',
    time: 'Tiempo',
    score: 'Puntuación',
    settings: 'Configuración',
    sounds: 'Sonidos',
    autocomplete: 'Autocompletar',
    leftHanded: 'Zurdo',
    newDeal: 'Nueva Baraja',
    design: 'Diseñar',
    easy: 'Fácil',
    medium: 'Medio',
    hard: 'Difícil',
    expert: 'Experto',
    master: 'Maestro',
    random: 'Aleatorio',
    rulesKlondikeURL: 'https://solitaires.com/es/articles/how-to-play-solitaire/',
    cardHighlight: 'Resaltar cartas',
    rulesSpiderURL: 'https://solitaires.com/es/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/es/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'Movimiento automático',
    noMagicNeeded: 'No necesitas Varita Mágica — continúa el juego tú mismo!',
    leaveFeedback: 'Deja tu comentario',
    feedbackThankYou: '¡Agradecemos tus comentarios!',
    feedbackError: 'Se produjo un error. Tu mensaje no fue enviado.',
    thanksSubscribing: '¡Gracias por suscribirte!',
};
